module.exports = __webpack_public_path__ + "media/images/dashcore/bg/home-back-f44a4573cd67fdc36d5b04addf877802.jpg";